// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"081e77b9","977":"6f046f52"}[chunkId] + ".chunk.js";
};